import React from 'react';
import ReactDOM from 'react-dom/client';
import "monday-ui-react-core/tokens";
import "monday-ui-react-core/dist/main.css";
import './styles/theme.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 